module.exports = __webpack_public_path__ + "img/1.49e6726a.png";